import { render, staticRenderFns } from "./Onboarding2.vue?vue&type=template&id=24582508&scoped=true&lang=html"
import script from "./Onboarding2.vue?vue&type=script&lang=js"
export * from "./Onboarding2.vue?vue&type=script&lang=js"
import style0 from "./Onboarding2.vue?vue&type=style&index=0&id=24582508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24582508",
  null
  
)

export default component.exports